import {
  Badge,
  BadgeFlavor,
  Copy,
  Flex,
  Link,
  Square,
  Squish,
} from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { copyVariants } from 'src/utilities/shared-types';
import { EXTERNAL_LINK_ATTRIBUTES } from 'src/utilities/externalLinkAttributes';
import { RouterLink } from 'src/components/RouterLink/RouterLink';

export interface IMenuItemProps {
  text: string;
  href: string;
  useRouterLink?: boolean;
  copyVariant?: copyVariants;
  copyColor?: string;
  hide?: boolean;
  badgeLabel?: string;
  badgeFlavor?: BadgeFlavor;
  openInNewTab?: boolean;
}

export function MenuSubItem({
  text,
  href,
  copyVariant = 'body',
  copyColor = 'primaryText',
  hide,
  useRouterLink,
  badgeLabel,
  badgeFlavor,
  openInNewTab,
}: IMenuItemProps): JSX.Element {
  if (hide) {
    return null;
  }

  if (useRouterLink) {
    return (
      <RouterLink href={href}>
        <MenuSubItemElement
          text={text}
          copyVariant={copyVariant}
          copyColor={copyColor}
          badgeLabel={badgeLabel}
          badgeFlavor={badgeFlavor}
        />
      </RouterLink>
    );
  }

  const newTabProps = openInNewTab ? EXTERNAL_LINK_ATTRIBUTES : {};

  return (
    <Link href={href} {...newTabProps}>
      <MenuSubItemElement
        text={text}
        copyVariant={copyVariant}
        copyColor={copyColor}
        badgeLabel={badgeLabel}
        badgeFlavor={badgeFlavor}
      />
    </Link>
  );
}

function MenuSubItemElement({
  text,
  copyVariant,
  copyColor,
  badgeLabel,
  badgeFlavor,
}: Partial<IMenuItemProps>): JSX.Element {
  return (
    <Squish
      className="subItem"
      inset="sm"
      bg="globals.white"
      borderBottomStyle="solid"
      borderBottomColor="lightLine"
      borderBottomWidth={1}
    >
      <Square padding="8px">
        <Flex alignItems="center" justifyContent="space-between">
          <Copy
            className="menuSubItemText"
            variant={copyVariant}
            color={copyColor}
          >
            {text}
          </Copy>
          {badgeLabel && (
            <Badge label={badgeLabel} flavor={badgeFlavor} size="sm" />
          )}
        </Flex>
      </Square>
    </Squish>
  );
}
